//Форматирования числа в строку с разбивкой (1000000 -> 1 000 000)
var numberFormat = function (num) {
	num = String(num);
	return num.replace(/[^0-9]/g,'').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
};

export { numberFormat }
